import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientAction } from '../symbolClient.action';

type IDependencies = IClientApiDependencySegment;

export const removeSymbolClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteClientSymbol(params).pipe(
      mergeMap(() => {
        return [
          SymbolClientAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolClientAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
